import { AbstractFilterModel } from "@gipi-pages/abstract/models/abstract-filter.model";
import { GIPIUuid } from "@gipi-shared/types/uuid.type";

export class NotificationViewFilterDTO extends AbstractFilterModel {

    notificationId: GIPIUuid;

}
